import { NgModule } from "@angular/core";

import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from "app/app.routing";
import { FormConsulterComponent } from "app/components/form-consulter/form-consulter.component";
import { FormConsultantComponent } from "app/components/form-consultant/form-consultant.component";
import { FormStatusComponent } from "app/components/form-status/form-status.component";

import { DropdownComponentModule } from "app/components/dropdown/dropdown.module";
import { DatePickerModule } from "app/components/date/datepicker.module";

import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { TooltipModule, CollapseModule } from 'ngx-bootstrap';
import { ConsultService } from "app/services/consult/consult.service";
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap';
import { FormHarassmentTypeComponent } from "app/components/form-setting/form-harassment-type.component";
import { MasterService } from "app/services/master/master.service";
import { FormInjuryTimeComponent } from "app/components/form-setting/form-injury-time.component";
import { FormConsultantUserComponent } from "app/components/form-setting/form-consultant-user.component";
import { FormSystemAdminComponent } from "app/components/form-setting/form-system-admin.component";
import { WalkthroughModule } from "ngx-walkthrough";
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { FormNotificationComponent } from "app/components/form-setting/form-notification.component";




@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownComponentModule,
        DatePickerModule,
        NKDatetimeModule,
        CollapseModule,
        AppRoutingModule,
        WalkthroughModule,
        RecaptchaModule.forRoot(), 
        RecaptchaFormsModule,
        TooltipModule.forRoot(),
        ModalModule.forRoot(),
        AlertModule.forRoot()
    ],
    declarations: [ 
        FormConsulterComponent, 
        FormConsultantComponent, 
        FormHarassmentTypeComponent,
        FormInjuryTimeComponent,
        FormConsultantUserComponent,
        FormSystemAdminComponent,
        FormNotificationComponent,
        FormStatusComponent ],
    providers: [
        ConsultService,
        MasterService,
        DatePipe
    ],
    exports: [ 
        FormConsulterComponent,
        FormConsultantComponent, 
        FormHarassmentTypeComponent,
        FormInjuryTimeComponent,
        FormConsultantUserComponent,
        FormSystemAdminComponent,
        FormNotificationComponent,
        FormStatusComponent ]
})
export class FormCompnentModule {}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form/form.module.ts